import { marketing } from 'app/concerns'

export default {
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$marketing', {
      get() {
        return marketing({
          account: this.$store.getters['accounts/currentAccount'],
          subscription: this.$store.getters['subscriptions/currentSubscription']
        })
      }
    })
  }
}
